import styled from '@emotion/styled';
import React from 'react';
import { connect } from 'react-redux';

import Select, { SelectOption } from '../../../shared/Select/index.jsx';
import { BackArrow } from '../../../shared/svgIcons.jsx';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';

const StepWrapper = styled.div`
  max-width: 23.125rem;
  width: 100%;
`;

const IntroMessage = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: #333333;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
  text-transform: none;
`;

const NextButton = styled.button`
  background-color: #d40f7d;
  border: none;
  color: #ffffff;
  cursor: pointer;
  font-size: 18px;
  padding: 0.5rem;
  width: 100%;
  margin-top: 1.5rem;

  :disabled {
    background-color: #d8d8d8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  color: #333333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;

  h3 {
    font-weight: 700;
    font-size: 16px;
    color: #000;
    text-transform: uppercase;
    font-family: 'OCRoboto';
  }
`;

const BackText = styled.p`
  margin-top: 0.5rem;
  padding-bottom: 1.5rem;
  text-align: center;
  font-size: 12px;
`;

const SplitInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;

  > div {
    width: 48%;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const mapStateToProps = state => ({
  formData: state.formData,
});

const genericTypes = ['', ['Residential (Single-Family Detached)', 'Single family detached'], ['Other', 'Other']];
const otherTypes = [
  '',
  'Apartments',
  'Civic or Government',
  'Commercial',
  'Condominiums',
  'Homeowners Association',
  'Industrial',
  'Religious or Church',
  'Retail',
  'School',
  'Not Listed',
];

const HomeownerStep9 = ({ incrementStep, decrementStep, formData }) => {
  const validated = formData.propertyType === 'Other' ? formData.subPropertyType : formData.propertyType;

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 10 - what is the type of property"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <h3>Back</h3>
        <BackText>Which contractor installed your roof?</BackText>
      </BackWrapper>
      <IntroMessage>
        Next, we’re going to ask a few questions about the products purchased for your new roof.
      </IntroMessage>
      <Header>What is the type of property where the roof was installed?</Header>
      <InputWrapper>
        <Select
          value={formData.propertyType || ''}
          fieldKey="propertyType"
          options={genericTypes.map(([text, value], index) => (
            <SelectOption key={index} value={value} text={text} />
          ))}
          htmlAttributes={{
            placeholder: 'Select Property Type',
          }}
        />
      </InputWrapper>
      {formData.propertyType === 'Other' && (
        <InputWrapper>
          <Select
            value={formData.subPropertyType || ''}
            fieldKey="subPropertyType"
            options={otherTypes.map((type, index) => (
              <SelectOption key={index} value={type} text={type} />
            ))}
            htmlAttributes={{
              placeholder: 'Select Property Type',
            }}
          />
        </InputWrapper>
      )}
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Registration"
        data-track-form-step="step 10 - what is the type of property"
        onClick={incrementStep}
        disabled={!validated}
      >
        Next
      </NextButton>
    </StepWrapper>
  );
};

const mapDispatchToProps = dispatch => ({
  incrementStep: () => dispatch(incrementStep()),
  decrementStep: () => dispatch(decrementStep()),
  setFormData: hash => dispatch(setFormData(hash)),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomeownerStep9);
